const ReportsContent = () => {
  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-3xl font-semibold text-blue-800 mb-6">
        Check and Download the Reports
      </h1>
      <b>
        To check the report for the security events or attack alerts, you have
        two options:
      </b>
      <b>Using the Reports Button:</b>
      <ul className="flex flex-col gap-4 list-disc ml-6">
        <li>
          Navigate to the top Navigation Bar and click on the Reports tab.
        </li>
        <li>
          This will take you to the reports section, where you can generate
          detailed reports based on the security alerts, intrusions, or system
          activity over a specific time range.
        </li>
      </ul>
      <img src="" className="size-2/3" />
      <ul className="flex flex-col gap-4 list-disc ml-6">
        <li>
          <b>Time:</b> The exact timestamp when the alert was generated (e.g.,
          10/4/2024,1:30:01PM).
        </li>
        <li>
          <b>Agent:</b> The identifier for the agent monitoring the system
          (e.g., 007).
        </li>
        <li>
          <b>Agent Name: </b> The name of the monitored system (e.g.,
          chess-ams).
        </li>
        <li>
          <b>Technique(s) and Tactic(s):</b> These columns may refer to the
          MITRE ATT&CK framework, but in this case, there are no specific
          techniques or tactics listed.
        </li>
        <li>
          <b>Description:</b> A brief description of the event, such as "Web
          server 400 error code."
        </li>
        <li>
          <b>Level:</b> The severity level of the alert (e.g., 5).
        </li>
        <li>
          <b>Rule ID:</b>The unique identifier of the rule that triggered the
          alert (e.g., 31101).
        </li>
      </ul>
      <b>Clicking on the Alert Count (33Alerts):</b>
      <img src="" className="size-2/3" />
      <ul className="flex flex-col gap-4 list-disc ml-6">
        <li>On the dashboard, click on the 33 alert count (shown in red).</li>
        <li>
          This will direct you to a detailed log of all the attack alerts,
          showing the time, groups, severity, and descriptions of each alert.
          From here, you can further investigate individual alerts by reviewing
          their details or generating a report based on this data.
        </li>
      </ul>
      <hr />
      <p>
        You also have the option to filter the alerts by timeframe (Last 1 hour,
        12 hours, or 24 hours) and download the alert data as an Excel file for
        further analysis.
      </p>
      <b>To downloading Alert data as excel:</b>
      <ul className="flex flex-col gap-4 list-disc ml-6">
        <li> Navigate to the Report button</li>
        <li>Select SYSTEM and TIMEFRAME</li>
        <li>Select Download as EXCEL</li>
      </ul>
      <img src="" className="size-2/3" />
      <img src="" className="size-2/3" />

      <p>
        Above Xl sheet shows a log file containing data from a security
        monitoring system . It captures information about web server activities,
        with columns detailing the timestamp, rule numbers (e.g., 31101),
        descriptions of the activity (e.g., "Web server"), and log levels
        (indicating severity). The "FULL_LOG" column contains detailed JSON data
        showing the agent's IP address, protocol (e.g., GET or POST), status
        codes (e.g., 404 or 405), and URLs accessed. This log helps in tracking
        and analyzing potential security incidents or web server issues.
      </p>
    </div>
  );
};

export default ReportsContent;
